import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { UserInfo } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';
import { EditUserDialogComponent } from '../dialogs/edit-user-dialog/edit-user-dialog.component';
import { LockUserDialogComponent } from '../dialogs/lock-user-dialog/lock-user-dialog/lock-user-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-member-settings',
  templateUrl: './member-settings.component.html',
  styleUrls: ['./member-settings.component.scss']
})
export class MemberSettingsComponent {
  allUsers = new MatTableDataSource<UserInfo>([]);
  displayedColumns: string[] = [
    'username',
    'firstName',
    'idNumber',
    'action',
  ];

  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService, 
    private router: Router,
    public dialog: MatDialog) {}

    
  ngOnInit(): void {
    this.userService
      .getMembers()
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.userService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.allUsers.data = data || [];
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openEditMemberDialog(user: UserInfo): void {
    const dialogRef = this.dialog.open(EditUserDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: { user: user },
    });
  }

  impersonate(user: UserInfo): void {
    this.userService.toggleImpersonate(user.username, true);
    this.router.navigate(['']);
  }

  openLockDialog(user: UserInfo): void {
    const dialogRef = this.dialog.open(LockUserDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: { user: user },
    });
  }
}
